import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import { Breadcrumb } from "react-bootstrap";
import BookingWithCounselor from "./BookingWithCounselor";

const BookingCounselorMaster = () => {
  return (
    <MasterLayout>
      <Breadcrumb title="Booking List" />
      <BookingWithCounselor />
    </MasterLayout>
  );
};

export default BookingCounselorMaster;
